module.exports = __webpack_public_path__ + "img/02.252ba49a.jpg";